import { Item } from "@/api";
import { formatDate, formatFloat } from "@/utils/format";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useRef, useEffect, useMemo } from "react";

interface ItemProductionSummaryProps {
  items: Item[],
  日付: string[],
  shipments: Record<Item["品目ID"], number[]>;
  productions: Record<Item["品目ID"], number[]>;
  inventories: Record<Item["品目ID"], number[]>;
  compare?: boolean; // 比較モードを有効にするためのプロパティを追加
}

const ItemProductionSummary : React.FC<ItemProductionSummaryProps> = ({items,日付,shipments,inventories,productions,compare = false}) => {
  const data = useMemo(() => {
    return items.map(item => {
      const productionDate= []
      for (let i = 0; i < 日付.length; i++) {
        if (productions[item.品目ID]?.[i] > 0) {
          const date = formatDate(日付[i])
          productionDate.push(date)
        }
      }
      return {
        ...item,
        在庫切れ日数: inventories[item.品目ID]?.filter(i=>i < 0).length ?? 0,
        在庫切れ個数: inventories[item.品目ID]?.filter(i=>i < 0).reduce((acc, i) => acc + i, 0) ?? 0,
        生産日数: productions[item.品目ID]?.filter(i=>i > 0).length ?? 0,
        生産個数: productions[item.品目ID]?.reduce((acc, i) => acc + i, 0) ?? 0,
        次月生産計画: item.次月生産計画.value,
        生産日: productionDate.length > 0 ? productionDate.join(',') : 'なし',
      }
    })
  }
  , [items, shipments, productions, inventories])
  return (
    <>
    <DataTable
      value={data}
      stripedRows
      showGridlines
      tableStyle={{ minWidth: '50rem' }}
      className="w-full"
      dataKey="品目ID"
    >
      <Column field="品目ID" header="品目ID" sortable style={{minWidth: "4rem"}} />
      <Column field="品目名" header="品目名" sortable style={{minWidth: "10rem"}}/>
      <Column field="在庫切れ日数" header="在庫切れ日数" sortable style={{minWidth: "10rem"}}/>
      <Column field="在庫切れ個数" header="在庫切れ個数" sortable style={{minWidth: "10rem"}}/>
      <Column field="生産日数" header="生産日数" sortable style={{minWidth: "10rem"}}/>
      <Column field="次月生産計画" header="次月生産計画" sortable style={{minWidth: "10rem"}}/>
      <Column field="生産個数" header="生産個数" sortable style={{minWidth: "10rem"}}/>
      <Column field="生産日" header="生産日" sortable />
      </DataTable>
    </>
  )
}

export default ItemProductionSummary
